const ROUTE_PATHS = {
  HOME: "/",
  COMMERCIAL_AIRLINE_HOME: "/commercial-airline",
  COMMERCIAL_AIRLINE_FLIGHT_ROSTER: "/commercial-airline/flight-roster",
  COMMERCIAL_AIRLINE_FLIGHT_ROSTER_EDIT:
    "/commercial-airline/flight-roster/edit",
  COMMERCIAL_AIRLINE_CREATE_FLIGHT_PLAN:
    "/commercial-airline/flight-roster/create-flight-plan",
  COMMERCIAL_AIRLINE_SPECIAL_ONBOARDING:
    "/commercial-airline/flight-roster/special-onboarding/:type",
  COMMERCIAL_AIRLINE_ACCOUNT_MAINTENANCE:
    "/commercial-airline/account-maintenance",
  COMMERCIAL_AIRLINE_CONCESSION_FEE: "/commercial-airline/concession-fee",
  COMMERCIAL_AIRLINE_INVOICE: "/commercial-airline/invoice",
  COMMERCIAL_AIRLINE_INVOICE_DETAILS: "/commercial-airline/invoice/details",
  COMMERCIAL_AIRLINE_INVOICE_RECEIPT:
    "/commercial-airline/invoice/details/receipt",
  COMMERCIAL_AIRLINE_INVOICE_FEE_INVOICE_DETAILS:
    "/commercial-airline/invoice/details/fee-invoice-details",
  COMMERCIAL_AIRLINE_HISTORICAL_DATA_VIEW:
    "/commercial-airline/flight-roster/historical-data/view",
  COMMERCIAL_AIRLINE_VIEW_SPECIAL_ONBOARDING:
    "/commercial-airline/special-onboarding/view",
  COMMERCIAL_AIRLINE_VIEW_SPECIAL_ONBOARDING_TRIP_DETAILS:
    "/commercial-airline/special-onboarding/view/trip-details",
  COMMERCIAL_AIRLINE_ESCORT_DETAILS: `/commercial-airline/special-onboarding/escort-details/:flightNumber/:flightId`,
  COMMERCIAL_AIRLINE_DATA_SOURCE: `/commercial-airline/data-source`,
  COMMERCIAL_AIRLINE_DATA_SOURCE_AIRLINES: `/commercial-airline/data-source/airlines`,
  COMMERCIAL_AIRLINE_DATA_SOURCE_AVIATION_STACK_FAILURE: `/commercial-airline/data-source/flight-data-failure`,
  COMMERCIAL_AIRLINE_DATA_SOURCE_AVIATION_STACK_SUCCESS: `/commercial-airline/data-source/flight-data-success`,
  COMMERCIAL_AIRLINE_NOTIFICATIONS: "/commercial-airline/notifications",
  COMMERCIAL_AIRLINE_INVOICING_IATA: `/commercial-airline/invoicing-IATA`,
  COMMERCIAL_AIRLINE_INVOICING_IATA_PAYMENT_RECIEPT: `/commercial-airline/invoicing-IATA/payment-reciept`,
  COMMERCIAL_AIRLINE_INVOICING_IATA_VIEW: `/commercial-airline/invoicing-IATA/View`,
  COMMERCIAL_AIRLINE_INVOICING_IATA_VIEW_FLIGHT_DETAILS: `/commercial-airline/invoicing-IATA/View/IATA Flight Details`,
  COMMERCIAL_AIRLINE_INVOICE_CONCESSION_FEE_DETAILS: `/commercial-airline/invoice/details/concession-fee-details`,
  COMMERCIAL_AIRLINE_PASSENGER_DISPUTE_COUNT_DETAILS: `/commercial-airline/passenger-dispute-count/details`,
};

export default ROUTE_PATHS;
